import appConfig from '../../../config/appConfig';

var itemConfig = {
  apiUrl: appConfig.apiUrl + 'items/',
  itemsFastSearchUrl:  appConfig.apiUrl + 'items/fastsearch/',
  currentStockReportDownloadUrl:  appConfig.apiUrl + 'reports/current_stock/',
  withdrawalReportDownloadUrl:  appConfig.apiUrl + 'reports/item_withdrawals/'
};

export default itemConfig;



// WEBPACK FOOTER //
// ./src/components/items/config/itemConfig.js